<template>
  <div class="row myrow content-mb-42">
    <div class="col-xs-12 mycol">
      <table class="c-indicator c-indicator-w-100">
        <TableHead></TableHead>
        <tbody>
          <TableRow
            v-for="(doc, docIndex) in docs"
            :index="index"
            :doc-index="docIndex"
            :doc="doc"
            :document-conf="documentConf"
            :document-history="documentHistory"
          ></TableRow>
          <UploadRow
            :sub-index="0"
            :docs="docs"
            :project="project"
            :document-conf="documentConf"
          ></UploadRow>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import TableHead from "@/components/project/documents/TableHead";
import TableRow from "@/components/project/documents/TableRow";
import UploadRow from "@/components/project/documents/UploadRow";

export default {
  components: { UploadRow, TableRow, TableHead },
  props: ["docs", "documentConf", "index", "project", "documentHistory"],
  name: "DocumentTable"
};
</script>

<style scoped></style>
